import { object, array, string, number } from 'yup';
import { lt } from 'yup-locales';
import { setLocale } from 'yup';

setLocale(lt);

export interface UserFormInterface {
  customer_email: string
  customer_parent_name: string,
  customer_name: string,
  customer_age: number, // Keep for backward compatibility, will be calculated from child_birth_date
  child_birth_date: string, // Child's birth date for PostgreSQL backend
  customer_phone_no: string,
  customer_address: string,
  day_selected: string,
  customer_guests: number,
  time_selected: string | null,
  invitation_type: string,
  discount_code: string,
  services_selected: string[],
  print_invites: string,
  phone_in_invitation: string,
  city_uuid: string, // Added city_uuid
  // BDAR consent fields
  marketing_consent: string,
  data_processing_consent: string,
  // Dvynių / dviejų vaikų gimtadienis
  is_twin_birthday: boolean,
  is_two_children_birthday: boolean,
  child_name_2: string,
  child_birth_date_2: string,
  child_age_2: number
}

export const formSchema = object({
  customer_email: string().label("El. paštas").required().email(),
  customer_parent_name: string()
    .label("Vieno iš tėvų vardas")
    .required()
    .min(3)
    .max(40)
    .matches(
      /^[^0-9]{3,}$/,
      'Prašome įvesti vardą ir pavardę. Negalima naudoti skaičių.'
    ),
  customer_name: string()
    .label("Vaiko vardas")
    .required()
    .min(2)
    .max(40)
    .matches(
      /^[^0-9]*$/,
      'Vardas negali turėti skaičių.'
    ),
  customer_age: number().label("Amžius").required().min(4).max(99),
  child_birth_date: string().label("Gimimo data").required(),
  customer_guests: number().label("Svečių skaičius").required().min(1).max(24),
  customer_phone_no: string()
    .label("Telefono numeris")
    .required()
    .matches(
      /^\d{8}$/,
      { message: "Įveskite tik 8 skaitmenų telefono numerį be šalies kodo. Sistema automatiškai prideda +370." }
    ),
  day_selected: string(),
  time_selected: string(),
  invitation_type: string().required().label("Pakvietimas"),
  discount_code: string(),
  print_invites: string().required().oneOf(["true", "false"]),
  phone_in_invitation: string().required().oneOf(["true", "false"]),
  services_selected: array().of(string().required().length(32)),
  customer_address: string().label("Adresas").required().min(5, "Adresas turi būti bent 5 simbolių").max(100),
  // Consent fields
  marketing_consent: string().required().oneOf(["true", "false"]),
  data_processing_consent: string().required().oneOf(["true", "false"]),
  // Dvynių / dviejų vaikų gimtadienis - validated manually in Step2
});